/** 
 * @type {{
 *    currentUser: User,
 *    commonMicromodalConfig: import('micromodal').MicroModalConfig
 * }}
 */
const globals = {
   commonMicromodalConfig: {
      disableScroll: true,
      awaitCloseAnimation: true,
   },
};

export default globals;